import { Container } from 'react-bootstrap';
import { useState } from 'react';
import { Upload } from '../FormFields/Upload';
import { ControlButtons } from '../ControlButtons';

export const SiteMap = ({
	currSiteMap = {},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
	enableLoading = false,
}) => {
	const [currFile, setCurrFile] = useState(currSiteMap.file);
	const [currAnswer, setCurrAnswer] = useState(currSiteMap.answer);

	return (
		<>
			<Container className="component mt-5">
				<h2 className="mb-4">Do you have a site map?</h2>
				<Upload
					className="mt-4"
					file={currFile}
					setFile={setCurrFile}
					answer={currAnswer}
					setAnswer={setCurrAnswer}
				/>
			</Container>
			<Container>
				<ControlButtons
					onSubmit={() => onSubmit({ file: currFile, answer: currAnswer })}
					onNext={() => onNext({ file: currFile, answer: currAnswer })}
					onPrev={onPrevious}
					finalStep={finalStep}
					disableNext={currAnswer === null || (currAnswer && !currFile)}
					disablePrev={disablePrev}
					enableLoading={enableLoading}
				/>
			</Container>
		</>
	);
};
